export const CHANNEL = 'p2p';
export const PATH_PREFIX = '/health-services';
export const PLATFORM_API = '$PLATFORM_API';
export const TEALIUM_ENVIRONMENT = '$TEALIUM_ENVIRONMENT';
export const DEFAULT_PLATFORM_API = 'http://localhost:3000/v1/graphql?env=master';
export const GRAPHQL_TYPE_NAME = 'TheHub';
export const BATCH_SIZE = 20;
export const CONTENT_CONNECTOR_BATCH_SIZE = 9;

export const TEALIUM_TRACKING_INFO = {
  channel: 'Online',
  page_type: `content`,
  site_name: 'nib.com.au',
  site_section: 'P2P',
};

export type TealiumOptions = {
  account: string;
  profile: string;
  environment: string;
};

type TealiumConfig = { tealium: TealiumOptions };

declare global {
  interface Window {
    __CONFIG__?: TealiumConfig;
  }
}

const defaultTealiumOptions = { account: 'nib', profile: 'main', environment: TEALIUM_ENVIRONMENT };

export const tealiumConfig =
  typeof window === 'undefined' || !window?.__CONFIG__ ? defaultTealiumOptions : window.__CONFIG__?.tealium;

export const getTemplatedConstantOrDefault = (value: string, defaultValue: string) => {
  if (!value || value.startsWith('$')) {
    return defaultValue;
  }
  return value;
};

export const graphqlEndpoint = getTemplatedConstantOrDefault(PLATFORM_API, DEFAULT_PLATFORM_API);
